import { getScriptData } from './utils.m.js';
const { mehrwertNrRequestPath } = getScriptData(import.meta.url);

$('#AnzeigenSuchenButton').on('click', function () {
	window.location.href = `${mehrwertNrRequestPath}?id=${encodeURIComponent($('#MehrwertNr').val())}`;
});

const textboxHelper = new JJK.TextBoxHelper();
textboxHelper.LabelInTextbox('#MehrwertNr', '#MehrwertNrSpan');

$('#MehrwertNr').on('keydown', function (e) {
	if (e.which === 13) {
		window.location.href = `${mehrwertNrRequestPath}?id=${encodeURIComponent($('#MehrwertNr').val())}`;
		return false;
	}
	return true;
});

$('#loginForm .col-sm-6').removeClass('col-sm-6');
